import { combineReducers } from 'redux';

import analyticsDashboard from './analyticsDashboard';
import customers from './customers';
import dashboard from './dashboard';
import dispatch from './dispatch';
import globalSettings from './globalSettings';
import invoices from './invoices';
import messenger from './messenger';

export default combineReducers({
	globalSettings,
	analyticsDashboard,
	dashboard,
	dispatch,
	customers,
	invoices,
	messenger,
});
